import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { resources } from './locales/resources.js';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'zh',
    supportedLngs: ['zh', 'en'],
    defaultNS: 'common',
    ns: [
      'common',
      'feedback',
      'contractExport',
      'nav',
      'entityList',
      'quoteDetail',
      'boqConfigurator',
      'columnVisibility',
      'financeCollections',
      'salesList',
      'roleList',
      'userAvatar',
      'header',
      'inbox',
      'reporting',
      'knowledgeBaseManagement',
      'openVikingStudio',
      'openVikingConsole',
      'assistantDefinitionForm',
      'orchestrationCanvas',
      'orchestrationNode',
      'orchestrationDebug',
      'orchestrationDetail',
      'detailNavigation',
      'opportunityDetail',
      'legacy',
      'hardcoded',
    ],
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  });

export default i18n;
